import { render, staticRenderFns } from "./SapphironComponent.vue?vue&type=template&id=7a0707a0&"
import script from "./SapphironComponent.vue?vue&type=script&lang=js&"
export * from "./SapphironComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports